import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/head.png'
import _imports_1 from '../assets/contactUsIcon.png'
import _imports_2 from '../assets/instructions.png'
import _imports_3 from '../assets/FAQ.png'
import _imports_4 from '../assets/AboutUs.png'


const _withScopeId = n => (_pushScopeId("data-v-49507072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portrait" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "phone" }
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_4,
  alt: ""
}, null, -1))

import { ref, inject } from "vue";
import { useRouter } from "vue-router";
import {
  Button,
  Field,
  Cell,
  CellGroup,
  Toast,
  NavBar,
  Tabs,
  Tab,
  List,
  Icon,
} from "vant";
import { Dialog } from "vant";

export default /*#__PURE__*/_defineComponent({
  name: 'MyPage',
  setup(__props) {

const router = useRouter();
const phone =
  localStorage.getItem("userInfo") &&
  JSON.parse(localStorage.getItem("userInfo")!).phone;
const hanleLogout = () => {
  Dialog.confirm({
    title: "提示",
    message: "请确认是否退出登录?",
  }).then(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    location.replace("/login");
  });
};
const handleShowCustomerService = inject("handleShowCustomerService") as () => void;
const handleKf = () => {
  handleShowCustomerService();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(phone)), 1)
      ]),
      _createElementVNode("div", {
        class: "logout",
        onClick: hanleLogout
      }, "退出登录")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: handleKf
      }, {
        icon: _withCtx(() => [
          _hoisted_7
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, " 联系客服", 4)
        ]),
        _: 1
      }),
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('instructions')))
      }, {
        icon: _withCtx(() => [
          _hoisted_8
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, " 使用说明", 4)
        ]),
        _: 1
      }),
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('questions')))
      }, {
        icon: _withCtx(() => [
          _hoisted_9
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, " 常见问题", 4)
        ]),
        _: 1
      }),
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('AboutUs')))
      }, {
        icon: _withCtx(() => [
          _hoisted_10
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, " 关于我们", 4)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})